<ng-container *ngIf="hasRows; else emptyState">
  <div class="gw-mb-medium gw-flex gw-flex-wrap gw-items-center gw-gap-small">
    <span class="gw-badge gw-bg-background-elevation-2 gw-text-text-primary">
      {{ totalRecordCount }}
      {{
        totalRecordCount === 1
          ? ('common.feeSnapshotTable.record' | translate)
          : ('common.feeSnapshotTable.records' | translate)
      }}
    </span>
  </div>

  <div
    class="gw-overflow-hidden gw-rounded-2xl gw-border gw-border-border-normal gw-bg-background-elevation-3"
  >
    <div class="gw-overflow-x-auto">
      <table class="gw-w-full gw-border-collapse gw-text-sm">
        <thead>
          <tr
            class="gw-border-b gw-border-border-normal gw-bg-background-elevation-2"
          >
            <th
              class="gw-w-12 gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
            >
              {{ 'common.feeSnapshotTable.columns.index' | translate }}
            </th>
            <th
              class="gw-min-w-[10rem] gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
            >
              {{ 'common.feeSnapshotTable.columns.paymentMethod' | translate }}
            </th>
            <th
              class="gw-w-28 gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
            >
              {{ 'common.feeSnapshotTable.columns.operation' | translate }}
            </th>
            <th
              class="gw-w-28 gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
            >
              {{ 'common.feeSnapshotTable.columns.feeType' | translate }}
            </th>
            <th
              class="gw-min-w-[9rem] gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
            >
              {{ 'common.feeSnapshotTable.columns.tierRange' | translate }}
            </th>
            <th
              class="gw-min-w-[8rem] gw-px-medium gw-py-small gw-text-right gw-text-xs gw-font-semibold gw-text-text-secondary"
            >
              {{ 'common.feeSnapshotTable.columns.value' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="let line of visibleLines; trackBy: trackVisibleLine"
          >
            <!-- Main data row -->
            <tr
              *ngIf="line.type === 'row'"
              class="gw-border-b gw-border-border-normal gw-transition-colors hover:gw-bg-background-neutral-1"
              [class.gw-bg-background-neutral-1]="
                line.isGroupPrimary && line.hiddenCount
              "
            >
              <td
                class="gw-px-medium gw-py-small gw-align-middle gw-tabular-nums gw-text-text-secondary"
              >
                {{ line.rowIndex }}
              </td>
              <td class="gw-px-medium gw-py-small gw-align-middle">
                <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-small">
                  <ng-container *ngIf="line.row.useCashOutLabel; else pmPipe">
                    <span class="gw-font-medium gw-text-text-primary">{{
                      'common.feeSnapshotTable.cashOut' | translate
                    }}</span>
                  </ng-container>
                  <ng-template #pmPipe>
                    <span class="gw-font-medium gw-text-text-primary">{{
                      line.row.paymentMethod ?? undefined | paymentMethod
                    }}</span>
                  </ng-template>
                  <span
                    *ngIf="
                      line.row.installments !== null &&
                      line.row.installments !== undefined &&
                      line.row.installments > 0
                    "
                    class="gw-badge gw-bg-background-elevation-2 gw-text-text-primary gw-text-xs"
                  >
                    {{ line.row.installments }}x
                  </span>
                  <button
                    *ngIf="
                      line.isGroupPrimary && line.groupKey && line.hiddenCount
                    "
                    type="button"
                    class="gw-inline-flex gw-cursor-pointer gw-items-center gw-gap-2x-small gw-rounded-full gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-px-small gw-py-2x-small gw-text-xs gw-font-medium gw-text-text-primary transition-colors hover:gw-bg-background-neutral-1-hover"
                    [attr.aria-expanded]="
                      isCreditCardGroupExpanded(line.groupKey!)
                    "
                    [attr.aria-label]="
                      (isCreditCardGroupExpanded(line.groupKey!)
                        ? 'common.feeSnapshotTable.collapseCreditCardFees'
                        : 'common.feeSnapshotTable.expandCreditCardFees'
                      ) | translate
                    "
                    (click)="toggleCreditCardGroup(line.groupKey!)"
                  >
                    {{
                      'common.feeSnapshotTable.creditCardInstallmentsHidden'
                        | translate : {count: line.hiddenCount}
                    }}
                    <gatewee-expand-chevron
                      class="gw-inline-flex gw-text-text-secondary"
                      [expanded]="isCreditCardGroupExpanded(line.groupKey!)"
                      size="14px"
                    ></gatewee-expand-chevron>
                  </button>
                  <span
                    *ngIf="line.row.brand"
                    class="gw-w-full gw-basis-full gw-text-xs gw-text-text-secondary"
                  >
                    {{ 'common.feeSnapshotTable.columns.brand' | translate }}:
                    {{ line.row.brand }}
                  </span>
                </div>
              </td>
              <td
                class="gw-px-medium gw-py-small gw-align-middle gw-text-sm gw-text-text-primary"
              >
                <ng-container [ngSwitch]="line.row.operation">
                  <span *ngSwitchCase="'income'">{{
                    'common.feeSnapshotTable.operation.income' | translate
                  }}</span>
                  <span *ngSwitchCase="'cash_out'">{{
                    'common.feeSnapshotTable.operation.cashOut' | translate
                  }}</span>
                  <span *ngSwitchDefault>—</span>
                </ng-container>
              </td>
              <td class="gw-px-medium gw-py-small gw-align-middle">
                <span
                  class="gw-badge gw-text-xs"
                  [ngClass]="feeTypeBadgeClass(line.row.feeType)"
                >
                  <ng-container [ngSwitch]="line.row.feeType">
                    <span *ngSwitchCase="'rate'">{{
                      'common.feeSnapshotTable.feeType.rate' | translate
                    }}</span>
                    <span *ngSwitchCase="'amount'">{{
                      'common.feeSnapshotTable.feeType.amount' | translate
                    }}</span>
                    <span *ngSwitchDefault>{{
                      'common.feeSnapshotTable.feeType.mix' | translate
                    }}</span>
                  </ng-container>
                </span>
              </td>
              <td class="gw-px-medium gw-py-small gw-align-middle">
                <ng-container
                  *ngIf="!line.row.hasMultipleTiers; else multiTierRange"
                >
                  <span class="gw-text-sm gw-text-text-primary">{{
                    line.row.tierRangeLabel
                  }}</span>
                </ng-container>
                <ng-template #multiTierRange>
                  <button
                    type="button"
                    class="gw-inline-flex gw-cursor-pointer gw-items-center gw-gap-2x-small gw-rounded-full gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-px-small gw-py-2x-small gw-text-xs gw-font-medium gw-text-text-primary transition-colors hover:gw-bg-background-neutral-1-hover"
                    [attr.aria-expanded]="
                      isTierRowExpanded(line.row.tierExpandKey)
                    "
                    (click)="toggleTierRow(line.row.tierExpandKey)"
                  >
                    {{ line.row.tierRangeLabel }}
                    <gatewee-expand-chevron
                      class="gw-inline-flex gw-text-text-secondary"
                      [expanded]="isTierRowExpanded(line.row.tierExpandKey)"
                      size="14px"
                    ></gatewee-expand-chevron>
                  </button>
                </ng-template>
              </td>
              <td
                class="gw-px-medium gw-py-small gw-align-middle gw-text-right"
              >
                <span
                  class="gw-font-semibold gw-tabular-nums gw-text-status-positive"
                >
                  {{ line.row.primaryDisplayValue }}
                </span>
              </td>
            </tr>

            <!-- Multi-tier breakdown -->
            <tr
              *ngIf="line.type === 'tier-panel'"
              class="gw-border-b gw-border-border-normal"
            >
              <td colspan="6" class="gw-p-0">
                <div
                  class="gw-ml-2x-large gw-mb-small gw-mr-medium gw-rounded-r-lg gw-border-l-2 gw-border-background-accent-1 gw-bg-background-elevation-2 gw-p-medium"
                >
                  <table class="gw-w-full gw-border-collapse gw-text-xs">
                    <thead>
                      <tr>
                        <th
                          class="gw-pb-small gw-pe-large gw-text-left gw-text-xs gw-font-semibold gw-uppercase gw-tracking-wide gw-text-text-secondary"
                        >
                          {{
                            'common.feeSnapshotTable.tiersPanel.range'
                              | translate
                          }}
                        </th>
                        <th
                          class="gw-pb-small gw-text-right gw-text-xs gw-font-semibold gw-uppercase gw-tracking-wide gw-text-text-secondary"
                        >
                          {{
                            'common.feeSnapshotTable.tiersPanel.value'
                              | translate
                          }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let tier of line.row.tiers"
                        class="gw-border-t gw-border-border-normal first:gw-border-t-0"
                      >
                        <td
                          class="gw-py-2x-small gw-pe-large gw-text-text-primary"
                        >
                          <span
                            *ngIf="isDefaultOpenTierRange(tier)"
                            class="gw-italic gw-text-text-secondary"
                            >{{
                              'common.feeSnapshotTable.tierAllAmounts'
                                | translate
                            }}</span
                          >
                          <span *ngIf="!isDefaultOpenTierRange(tier)">{{
                            tier.rangeLabel
                          }}</span>
                        </td>
                        <td class="gw-py-2x-small gw-text-right">
                          <span
                            class="gw-font-semibold gw-tabular-nums gw-text-status-positive"
                            >{{ tier.displayValue }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>

            <!-- Credit card installments (compact sub-table) -->
            <tr
              *ngIf="line.type === 'cc-installments'"
              class="gw-border-b gw-border-border-normal"
            >
              <td colspan="6" class="gw-p-0">
                <div
                  class="gw-ml-2x-large gw-mb-small gw-mr-medium gw-rounded-r-lg gw-border-l-2 gw-border-background-accent-1 gw-bg-background-elevation-2 gw-p-medium"
                >
                  <table class="gw-w-full gw-border-collapse gw-text-xs">
                    <thead>
                      <tr>
                        <th
                          class="gw-w-24 gw-pb-small gw-pe-large gw-text-left gw-text-xs gw-font-semibold gw-uppercase gw-tracking-wide gw-text-text-secondary"
                        >
                          {{
                            'common.feeSnapshotTable.installmentsPanel.installments'
                              | translate
                          }}
                        </th>
                        <th
                          class="gw-pb-small gw-pe-large gw-text-left gw-text-xs gw-font-semibold gw-uppercase gw-tracking-wide gw-text-text-secondary"
                        >
                          {{
                            'common.feeSnapshotTable.columns.tierRange'
                              | translate
                          }}
                        </th>
                        <th
                          class="gw-pb-small gw-text-right gw-text-xs gw-font-semibold gw-uppercase gw-tracking-wide gw-text-text-secondary"
                        >
                          {{
                            'common.feeSnapshotTable.installmentsPanel.fee'
                              | translate
                          }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let instRow of line.rows"
                        class="gw-border-t gw-border-border-normal first:gw-border-t-0"
                      >
                        <td class="gw-py-2x-small gw-pe-large">
                          <span
                            class="gw-badge gw-bg-background-elevation-3 gw-text-xs gw-font-semibold gw-text-text-primary"
                            >{{ instRow.installments }}x</span
                          >
                        </td>
                        <td
                          class="gw-py-2x-small gw-pe-large gw-text-text-secondary"
                        >
                          {{ instRow.tierRangeLabel }}
                        </td>
                        <td class="gw-py-2x-small gw-text-right">
                          <span
                            class="gw-font-semibold gw-tabular-nums gw-text-status-positive"
                            >{{ instRow.primaryDisplayValue }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<ng-template #emptyState>
  <div class="gw-text-center gw-py-2x-large">
    <gatewee-icon
      [icon]="'@tui.percent'"
      class="gw-text-4xl gw-text-text-secondary gw-mb-medium gw-inline-flex"
    ></gatewee-icon>
    <p class="gw-text-text-secondary">
      {{ 'common.feeSnapshotTable.emptyTitle' | translate }}
    </p>
    <p class="gw-text-sm gw-text-text-secondary">
      {{ 'common.feeSnapshotTable.emptyHint' | translate }}
    </p>
  </div>
</ng-template>
